import { render } from "./Tabs.vue?vue&type=template&id=0a91f01f&scoped=true&ts=true"
import script from "./Tabs.vue?vue&type=script&lang=ts"
export * from "./Tabs.vue?vue&type=script&lang=ts"

import "./Tabs.vue?vue&type=style&index=0&id=0a91f01f&scoped=true&lang=css"

import exportComponent from "/builds/digitalmasters/team-wombat/alenus-bottle-o-ionic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a91f01f"]])

export default __exports__